(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const stage = root.querySelector('[data-products]');
    const slides = [...root.querySelectorAll('.bw-slide')];
    const controls = root.querySelector('[data-motion-controls]');
    const toggle = root.querySelector('[data-motion-toggle]');
    const icon = root.querySelector('[data-motion-icon]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const setActive = index => {
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
      root.querySelectorAll('[data-product-select]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    };
    let started = false;
    let motionClock;
    const finish = () => {
      clearInterval(motionClock);
      root.dataset.motion = 'finished';
      root.dataset.staticIndex = '0';
      setActive(0);
      toggle.setAttribute('aria-label', toggle.dataset.replay);
      icon.textContent = '↻';
    };
    const start = () => {
      if (reduced.matches || root.dataset.expired === 'true' || !stage.animate) return;
      started = true;
      delete root.dataset.staticIndex;
      root.dataset.motion = 'manual';
      void stage.offsetWidth;
      root.dataset.motion = 'playing';
      toggle.setAttribute('aria-label', toggle.dataset.pause);
      icon.textContent = 'Ⅱ';
      clearInterval(motionClock);
      motionClock = setInterval(() => {
        if (root.dataset.motion !== 'playing') return;
        const animation = stage.querySelector('.bw-fullstop .bw-product-image').getAnimations()[0];
        const time = Number(animation?.currentTime || 0);
        setActive(time < 3550 || time > 11600 ? 0 : time < 7550 ? 1 : 2);
        if (time >= 12000 || animation?.playState === 'finished') finish();
      }, 150);
    };
    controls.hidden = false;
    toggle.addEventListener('click', () => {
      if (root.dataset.motion === 'playing') {
        root.dataset.motion = 'paused';
        toggle.setAttribute('aria-label', toggle.dataset.resume);
        icon.textContent = '▶';
      } else if (root.dataset.motion === 'paused') {
        root.dataset.motion = 'playing';
        toggle.setAttribute('aria-label', toggle.dataset.pause);
        icon.textContent = 'Ⅱ';
      } else start();
    });
    root.querySelectorAll('[data-product-select]').forEach(button => button.addEventListener('click', () => {
      started = true;
      clearInterval(motionClock);
      root.dataset.motion = 'manual';
      root.dataset.staticIndex = button.dataset.productSelect;
      setActive(Number(button.dataset.productSelect));
      toggle.setAttribute('aria-label', toggle.dataset.replay);
      icon.textContent = '↻';
    }));
    const applyReduced = () => { if (reduced.matches) finish(); };
    reduced.addEventListener('change', applyReduced);
    applyReduced();
    const ready = Promise.all([...stage.querySelectorAll('img')].map(img => img.decode().catch(() => {})));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          ready.then(() => { if (!started && !reduced.matches) start(); });
        }
      }, { threshold: 0.25 });
      observer.observe(stage);
    } else ready.then(() => { if (!started) start(); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && root.dataset.motion === 'playing') {
        root.dataset.motion = 'paused';
        toggle.setAttribute('aria-label', toggle.dataset.resume);
        icon.textContent = '▶';
      }
    });
    const target = Date.parse(root.dataset.launch);
    let expiryClock;
    const expire = () => {
      if (!Number.isFinite(target) || Date.now() < target) return;
      root.dataset.expired = 'true';
      root.querySelector('[data-expired-content]').hidden = false;
      finish();
      clearInterval(expiryClock);
    };
    expire();
    if (root.dataset.expired !== 'true' && Number.isFinite(target)) expiryClock = setInterval(expire, 1000);
    document.addEventListener('visibilitychange', expire);
    if (root.dataset.expired === 'true') return;
    const mount = root.querySelector('.bw-native-form');
    const loading = root.querySelector('[data-form-loading]');
    const fallback = root.querySelector('[data-form-fallback]');
    const updateForm = () => {
      const form = mount.querySelector('form');
      if (!form) return;
      loading.hidden = true;
      fallback.hidden = true;
      const email = form.querySelector('input[type=email]');
      if (!email) return;
      const button = [...form.querySelectorAll('button')].find(node => ['JOIN THE WAITLIST', 'NOTIFY ME'].includes(node.textContent.trim()));
      if (!button || button.textContent.trim() === root.dataset.cta) return;
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) if (node.nodeValue.trim() === 'JOIN THE WAITLIST') node.nodeValue = root.dataset.cta;
    };
    const observer = new MutationObserver(updateForm);
    observer.observe(mount, { childList: true, subtree: true, characterData: true });
    updateForm();
    setTimeout(() => { if (!mount.querySelector('form')) { loading.hidden = true; fallback.hidden = false; } }, 10000);
    const scripts = [...document.scripts].filter(script => script.src.includes('static.klaviyo.com/onsite/'));
    if (!scripts.some(script => !script.src.includes(root.dataset.account)) && !scripts.length) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://static.klaviyo.com/onsite/js/${root.dataset.account}/klaviyo.js?company_id=${root.dataset.account}`;
      document.head.append(script);
    }
    root.querySelector('[data-retry]').addEventListener('click', () => location.reload());
  };
  document.querySelectorAll('[data-bw-r9]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bw-r9]').forEach(initialize));
})();
